export default __webpack_public_path__ + "static/media/avatar_elephant2.381d2396.mp3";